import {
	ClientPortfolioPaymentFrequencyEnum,
	type PensionProductsDetailDataDTO,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { PENSION_EDIT_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormDefaults";
import type { PensionEditFormInput } from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";

export const mapPortfolioToPensionForm = (
	portfolio: PortfolioDetailResponseDTO,
): PensionEditFormInput => {
	const data = portfolio.data as PensionProductsDetailDataDTO | undefined;
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		payment: data?.payment ?? DEFAULTS.payment,
		paymentFrequency:
			data?.paymentFrequency &&
			data.paymentFrequency !== ClientPortfolioPaymentFrequencyEnum.None
				? data.paymentFrequency
				: DEFAULTS.paymentFrequency,
		employerContribution:
			data?.employerContribution ?? DEFAULTS.employerContribution,
		ageLimit: data?.ageLimit ?? DEFAULTS.ageLimit,
		appreciation: data?.appreciation ?? DEFAULTS.appreciation,
	};
};
